<mat-toolbar>
  <div class="nav-buttons">
    @for (button of buttons | async; track $index) {
      <button mat-button class="tab-button mat-body-large" [class.active]="button.isActive" appRestricted [permissions]="button.permissions" 
              (click)="onButtonClick(button.path, $event, button.isDisabled)"
      >
        {{ button.defaultText | translate : button.token }}
      </button>
    }
  </div>
  <div class="extra-buttons">
    <button mat-button class="help-button mat-label-large" (click)="onHelpClick()">
      <ogs-m3-icon icon="question-circle"/>
      {{"Benötigen Sie Hilfe?" | translate : "action-need-help" : "global"}}
    </button>
				@if(isProcessWheelSpinning()){
					<mat-spinner [diameter]="20"/>
				}
				<button mat-icon-button (click)="onActivityCenterClick()">
					@if(amountOfUnreadMessages() && amountOfUnreadMessages()! > 0){
						<ogs-m3-icon [matBadge]="amountOfUnreadMessages()" matBadgePosition="after" icon="bell"/>
					}@else {
						 <ogs-m3-icon icon="bell"/>
					}
    </button>
    <app-core-ui-header-dropdown-menu/>
  </div>
</mat-toolbar>
